// Coalesce duplicate reads only while they are in flight. No persisted customer data.
const pending = new Map();
export function loadBookingPageOnce(identity, request, fetchPage, {force=false}={}) {
  if(force)return Promise.resolve().then(fetchPage);
  const key = JSON.stringify([identity, request]);
  if (pending.has(key)) return pending.get(key);
  const promise = Promise.resolve().then(fetchPage).finally(() => {
    if (pending.get(key) === promise) pending.delete(key);
  });
  pending.set(key, promise);
  return promise;
}
